import axios from "axios";
export default {
    data() {
        return {};
    },
    methods: {
        getUser(role) {
            // 取得済みチェック
            if (this.$store.getters.userName != "") {
                // 権限チェック
                this.checkRole(role);
                return;
            }
            axios
                .get("/api/user")
                .then((response) => {
                    console.log(response);
                    this.$store.commit("setUserName", response.data.name);
                    this.$store.commit("setRoles", response.data.roles);
                    this.$store.commit("setSchoolCode", response.data.school_code);
                    this.$store.commit("setSchoolName", response.data.school_name);
                    // 権限チェック
                    this.checkRole(role);
                    // メニュー作成
                    let menuItems = [
                        {
                            id: 1,
                            label: "Dashboards",
                            icon: "bx-home-circle",
                            link: "/",
                            description: "システム全体のダッシュボードを表示します。", // 日本語の説明を追加
                        },
                    ];
                    if (response.data.roles == "admin") {
                        menuItems.push({
                            id: 10,
                            label: "Master",
                            icon: "bx-data",
                            description: "マスター管理のオプションを表示します。", // 日本語の説明を追加
                            subItems: [
                                {
                                    id: 11,
                                    label: "大会管理",
                                    link: "/game",
                                    parentId: 10,
                                },
                                {
                                    id: 12,
                                    label: "種目管理",
                                    link: "/event",
                                    parentId: 10,
                                },
                                {
                                    id: 13,
                                    label: "地区管理",
                                    link: "/school-area",
                                    parentId: 10,
                                },
                                {
                                    id: 14,
                                    label: "学校管理",
                                    link: "/school",
                                    parentId: 10,
                                },
                            ],
                        });
                        menuItems.push({
                            id: 40,
                            label: "Game",
                            icon: "bx-tennis-ball",
                            description: "大会情報を管理します。",
                            subItems: [
                                {
                                    id: 41,
                                    label: "選手管理",
                                    link: "/player",
                                    parentId: 40,
                                },
                                {
                                    id: 42,
                                    label: "校内順位管理",
                                    link: "/rank",
                                    parentId: 40,
                                },
                                {
                                    id: 43,
                                    label: "大会情報",
                                    link: "/game-info",
                                    parentId: 40,
                                },
                            ],
                        });
                        menuItems.push({
                            id: 20,
                            label: "Notice",
                            icon: "bx-notification",
                            description: "お知らせや通知を管理します。", // 日本語の説明を追加
                            subItems: [
                                {
                                    id: 21,
                                    label: "お知らせ",
                                    link: "/notice",
                                    parentId: 10,
                                },
                            ],
                        });
                        menuItems.push({
                            id: 30,
                            label: "Mail",
                            icon: "bx-envelope",
                            description: "メール送信と履歴を管理します。", // 日本語の説明を追加
                            subItems: [
                                {
                                    id: 31,
                                    label: "メール送信",
                                    link: "/mail",
                                    parentId: 30,
                                },
                                {
                                    id: 32,
                                    label: "送信履歴",
                                    link: "/mail-history",
                                    parentId: 30,
                                },
                            ],
                        });
                        menuItems.push({
                            id: 60,
                            label: "User",
                            icon: "bx-user",
                            description: "ユーザーアカウントを管理します。", // 日本語の説明を追加
                            subItems: [
                                {
                                    id: 61,
                                    label: "管理者",
                                    link: "/user?roles=admin",
                                    parentId: 60,
                                },
                                {
                                    id: 62,
                                    label: "ユーザー",
                                    link: "/user?roles=user",
                                    parentId: 60,
                                },
                            ],
                        });
                    }
                    if (response.data.roles == "user") {
                        menuItems.push({
                            id: 40,
                            label: "Game",
                            icon: "bx-tennis-ball",
                            description: "大会情報を管理します。",
                            subItems: [
                                {
                                    id: 41,
                                    label: "選手管理",
                                    link: "/player",
                                    parentId: 40,
                                },
                                {
                                    id: 42,
                                    label: "校内順位管理",
                                    link: "/rank",
                                    parentId: 40,
                                },
                                {
                                    id: 43,
                                    label: "大会情報",
                                    link: "/game-info",
                                    parentId: 40,
                                },
                            ],
                        });
                        menuItems.push({
                            id: 60,
                            label: "User",
                            icon: "bx-user",
                            description: "ユーザーアカウントを管理します。", // 日本語の説明を追加
                            subItems: [
                                {
                                    id: 62,
                                    label: "ユーザー",
                                    link: "/user?roles=user",
                                    parentId: 60,
                                },
                            ],
                        });
                    }
                    this.$store.commit("setMenuItems", menuItems);
                })
                .catch((error) => {
                    this.errorProcess(error);
                });
        },
        // 権限チェック
        // role: 必要な権限
        checkRole(role) {
            switch (this.$store.getters.roles) {
                case "admin":
                    break;
                case "user":
                    if (role != "user" && role != "guest") {
                        window.location.href = "/login";
                    }
                    break;
                default:
                    window.location.href = "/login";
                    return;
            }
        },
        errorProcess(error) {
            console.log(error);
            switch (error?.response?.status) {
                case 400:
                    this.$toasted.error(error.response.data.message);
                    return;
                case 401:
                    window.location.href = "/login";
                    return;
                default:
                    break;
            }
            if (error?.message === undefined) {
                this.$toasted.error(error);
                return;
            }
            this.$toasted.error(error.message);
        },
    },
};
